webpackJsonp([10],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy_part/privacy_part.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy_part.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-be5b553a", Component.options)
  } else {
    hotAPI.reload("data-v-be5b553a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_part_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy_part_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__privacy_part_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__privacy_part_vue___default.a);
  }
}).$mount('#privacy');

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__terms_terms_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__terms_terms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__terms_terms_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacy_CZUR_privacy_CZUR_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacy_CZUR_privacy_CZUR_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__privacy_CZUR_privacy_CZUR_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {};
  },

  components: {
    privacyCZUR: __WEBPACK_IMPORTED_MODULE_1__privacy_CZUR_privacy_CZUR_vue___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_0__terms_terms_vue___default.a
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    staticClass: "body-content"
  }, [_c('terms'), _vm._v(" "), _c('privacyCZUR')], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be5b553a", module.exports)
  }
}

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2b098c10", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-be5b553a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_part.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-be5b553a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_part.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(66),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/privacy_CZUR/privacy_CZUR.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] privacy_CZUR.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76cde9fa", Component.options)
  } else {
    hotAPI.reload("data-v-76cde9fa", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(67),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/terms/terms.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] terms.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c89f091a", Component.options)
  } else {
    hotAPI.reload("data-v-c89f091a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'terms',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.18rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  margin-top: 0.5rem;\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.18rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('h1', [_vm._v("隐私政策")]), _vm._v(" "), _c('div', [_vm._v("最近更新：2022年8月8日")]), _vm._v(" "), _c('div', [_vm._v("请花一些时间熟悉我们的隐私政策，如果您有任何问题，请联系我们。")]), _vm._v(" "), _c('div', [_vm._v("大连成者科技有限公司及旗下各关联公司（以下统称“成者科技”）尊重并保护所有使用产品（包含：“成者CZUR”、“极简扫描”、“成者极简扫描”、“CZUR”等相关APP）或服务用户的个人隐私权。为了给您提供产品或服务，成者科技会按照本隐私权政策的规定使用和披露您的个人信息。但成者科技将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，成者科技不会将这些信息对外披露或向第三方提供。")]), _vm._v(" "), _c('div', [_vm._v("您在同意成者科技服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于成者科技服务使用协议不可分割的一部分，成者科技会不时更新本隐私权政策，请您关注。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("1、 我们收集哪些信息以及信息用途")]), _vm._v(" "), _c('div', [_vm._v("在您使用我们的产品或服务时，我们可能需要收集和使用的您的个人信息包括如下两种：")]), _vm._v(" "), _c('div', [_vm._v("a）为实现向您提供我们产品或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务；")]), _vm._v(" "), _c('div', [_vm._v("b）为实现向您提供我们产品或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品或服务的基本功能。")]), _vm._v(" "), _c('div', [_vm._v("1）您须授权我们收集和使用您个人信息的情形")]), _vm._v(" "), _c('div', [_vm._v("a）在您使用我们产品或服务过程中，为识别账号异常状态、安全地连接和管理智能硬件、智能硬件的异常状态、了解或优化相关产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息；我们可能会收集您的Wi-Fi信息、IP地址、位置信息、登录帐号信息、手机相关信息、智能设备相关信息，以及帐号和智能设备的关联信息。上述各项信息，详细列举如下：")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 成者科技登录帐号信息：帐号、昵称、头像信息。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 手机相关信息：硬件设备标识(设备硬件序列号、Mac地址、Android ID)、系统版本信息、系统语言。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 通过Wi-Fi或蓝牙连接的智能硬件设备：Wi-Fi信息（SSID,BSSID, Wi-Fi的Mac地址、Wi-Fi密码）、设备蓝牙Mac地址、设备ID、设备系统版本信息、系统语言、系统使用设置")]), _vm._v(" "), _c('div', [_vm._v("b）为了使您持续享受最新的服务，我们可能会使用您的“成者CZUR”应用的版本信息。同时，我们可能收集您已连接的智能设备列表和版本号信息，用于为您提供智能设备的升级功能，以确保您可以使用最新版本的服务（包括固件版本）。")]), _vm._v(" "), _c('div', [_vm._v("2）您可选择是否授权我们收集和使用您的个人信息的情形")]), _vm._v(" "), _c('div', [_vm._v("为使您更好的体验智能硬件设备的使用、控制、管理等，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用基础服务，但您可能无法使用这些可以为您所带来便利的附加功能。这些附加功能包括：")]), _vm._v(" "), _c('div', [_vm._v("a）人脸识别管理")]), _vm._v(" "), _c('div', [_vm._v("如果您通过“成者CZUR”连接了支持人脸识别功能的特定产品（如“明镜Mirror” 智能坐姿仪系列、“Auramate” 智能陪伴仪系列等产品），您可以录入人脸及坐姿图像进行更好的智能设备使用体验（识别自定义姿势、识别有人使用设备的报告）。您可以录入需要识别的人脸素材，您可以在对应的产品功能里来添加和删除人脸及坐姿图像。 如果您对我们识别的结果有疑问，您可以和我们反馈以帮助我们优化算法和模型。在此情况下，我们会收集您主动反馈的问题的图文信息。请您放心，您反馈的信息仅会用于优化算法和模型，不会用于其他用途。")]), _vm._v(" "), _c('div', [_vm._v("b） 用户反馈：")]), _vm._v(" "), _c('div', [_vm._v("我们可能收集您发给我们的反馈的问题、反馈日志，以及您填写的电话号码或邮箱，这些信息将用于让我们更好的了解您遇到的问题，以及联系您。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("2. 信息披露")]), _vm._v(" "), _c('div', [_vm._v("在如下情况下，成者科技将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：")]), _vm._v(" "), _c('div', [_vm._v("a) 经您事先同意，向第三方披露；")]), _vm._v(" "), _c('div', [_vm._v("b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；")]), _vm._v(" "), _c('div', [_vm._v("c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；")]), _vm._v(" "), _c('div', [_vm._v("d) 如您出现违反当地国家有关法律、法规或者成者科技服务协议或相关规则的情况，需要向第三方披露；")]), _vm._v(" "), _c('div', [_vm._v("e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；")]), _vm._v(" "), _c('div', [_vm._v("f) 在成者科技平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，成者科技有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。")]), _vm._v(" "), _c('div', [_vm._v("g) 其它成者科技根据法律、法规或者网站政策认为合适的披露。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("3. 征得授权同意的例外")]), _vm._v(" "), _c('div', [_vm._v("根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：")]), _vm._v(" "), _c('div', [_vm._v("a）与国家安全、国防安全有关的；")]), _vm._v(" "), _c('div', [_vm._v("b）与公共安全、公共卫生、重大公共利益有关的；")]), _vm._v(" "), _c('div', [_vm._v("c）与犯罪侦查、起诉、审判和判决执行等有关的；")]), _vm._v(" "), _c('div', [_vm._v("d）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；")]), _vm._v(" "), _c('div', [_vm._v("e）所收集的信息是您自行向社会公众公开的；")]), _vm._v(" "), _c('div', [_vm._v("f）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；")]), _vm._v(" "), _c('div', [_vm._v("g）根据您的要求签订合同所必需的；")]), _vm._v(" "), _c('div', [_vm._v("h）用于维护成者科技服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；")]), _vm._v(" "), _c('div', [_vm._v("i）为合法的新闻报道所必需的；")]), _vm._v(" "), _c('div', [_vm._v("j）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；")]), _vm._v(" "), _c('div', [_vm._v("k）法律法规规定的其他情形。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("4. 信息存储和交换")]), _vm._v(" "), _c('div', [_vm._v("成者科技收集的有关您的信息和资料将保存在成者科技及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或成者科技收集信息和资料所在地的境外并在境外被访问、存储和展示。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("5. Cookie的使用")]), _vm._v(" "), _c('div', [_vm._v("a) 在您未拒绝接受cookies的情况下，成者科技会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的成者科技平台服务或功能。")]), _vm._v(" "), _c('div', [_vm._v("b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的成者科技网络服务或功能。")]), _vm._v(" "), _c('div', [_vm._v("c) 通过成者科技所设cookies所取得的有关信息，将适用本政策。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("6、 信息安全")]), _vm._v(" "), _c('div', [_vm._v("a) 成者科技帐号均有安全保护功能，请妥善保管您的用户名及密码信息。成者科技将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。")]), _vm._v(" "), _c('div', [_vm._v("b) 在使成者科技网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是成者科技用户名及密码发生泄露，请您立即联络成者科技客服，以便成者科技采取相应措施。")]), _vm._v(" "), _c('div', [_vm._v("c) 成者科技不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和成者科技（含成者科技关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。")]), _vm._v(" "), _c('div', [_vm._v("d) 成者科技亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何成者科技平台用户如从事上述活动，一经发现，成者科技有权立即终止与该用户的服务协议。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("7. 软件隐私权限说明")]), _vm._v(" "), _c('div', [_vm._v("a) 显示弹框、全屏界面到其他应用上面。")]), _vm._v(" "), _c('div', [_vm._v("b) 允许应用修改或删除存储卡上的照片、媒体内容和文件。")]), _vm._v(" "), _c('div', [_vm._v("c) 允许应用基于GPS、基站、 Wi-Fi 等网络源获取位置信息。这可能会增加耗电量。")]), _vm._v(" "), _c('div', [_vm._v("d) 允许应用在后台运行时检索用户位置信息。")]), _vm._v(" "), _c('div', [_vm._v("e) 允许应用录制音频。")]), _vm._v(" "), _c('div', [_vm._v("f) 允许应用拍摄照片和视频。")]), _vm._v(" "), _c('div', [_vm._v("g) 允许应用读取存储卡上的照片、媒体内容和文件。")]), _vm._v(" "), _c('div', [_vm._v("h) 允许应用获取本机号码、通话状态以及拨打的号码。")]), _vm._v(" "), _c('div', [_vm._v("i) 修改设置应用中的设置项。")]), _vm._v(" "), _c('div', [_vm._v("j) 允许应用打开蓝牙权限，连接ble蓝牙设备。")]), _vm._v(" "), _c('div', [_vm._v("k) 为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("8. 第三方服务收集的信息和安全保障功能")]), _vm._v(" "), _c('div', [_vm._v("a)com.tencent.bugly(Bugly;腾讯Bugly)；收集信息：需要网络权限和存储权限，搜集brand、model等基本设备信息；使用目的：提供异常日志分析服务；收集方式：SDK对手机进行本地采集")]), _vm._v(" "), _c('div', [_vm._v("b) com.huawei.hms(华为;华为推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("c) com.sina.weibo(微博;新浪微博)；收集信息：设备信息；使用目的：用于分享，第三方登录；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("d) com.umeng(友盟)；收集信息：设备信息，用户的IMSI信息； 使用目的：用于第三方（微信、QQ）共享登录，分享；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("e) com.huawei.agconnect(华为;华为联运应用)；收集信息：设备信息；使用目的：华为应用市场分发服务；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("f) cn.jpush.android(极光;极光推送)；收集信息：设备信息、地理位置、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("g)com.tencent.mm(微信)；收集信息：MAC地址、唯一设备识别码；使用目的：购买VIP服务等；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("h)com.eg.android.AlipayGphone(支付宝)；收集信息：设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、AndroidID、SSID、BSSID、设备基础信息【机型\\厂商等】）、网络信息；使用目的：购买VIP服务等；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("i) com.xiaomi.mipush(小米;小米推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("j) com.heytap.mcs(OPPO;OPPO推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("k) com.vivo.push(VIVO;VIVO推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _c('div', [_vm._v("l) io.agora(声网) ；收集信息：设备类型、设备型号、CPU信息、电池电量信息、操作系统信息收发端用户ID、用户属性、频道信息、使用时长、频道内设置名称、日志；使用目的：提供视频与音频会议功能；收集方式：SDK对手机进行本地采集；")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("9. 适用于某些国家/地区的特别规定")]), _vm._v(" "), _c('div', [_vm._v("在中国（为本条款之目的，不包含港澳台地区）运营中收集和产生的个人信息遵守《中华人民共和国网络安全法》关于关键信息基础设施个人信息和重要业务数据出境的相关规定。 在中国香港特别行政区、澳门特别行政区和台湾地区，我们的产品和服务将遵守包括《香港个人资料（私隐）条例》在内的该等各地区的可适用法律规范的要求。")]), _vm._v(" "), _c('div', [_vm._v("在《欧盟通用数据保护条例》（EU General Data Protection Regulation）对我们提供的服务可适用的情形下，我们承诺，您同时享有该条例项下的相关权益，包括但不限于数据访问权（您可以从我们处获得关于是否正在处理与您有关的个人数据、处理地点以及处理目的的确认等）、数据迁移权（在有关条件下，依照您的请求，我们将向您提供符合该条例规定的形式的您的数据，或向指定的其他数据控制者传输您的数据）、被遗忘权（在有关条件下，依照您的请求，我们将无不当延误地删除所有有关您的个人数据）。")]), _vm._v(" "), _c('div', [_vm._v("在美国，我们的产品和服务将遵守包括美国《隐私权法案》（Privacy Act）、《电子通信隐私法案》（Electronic Communications Privacy Act）、《儿童在线隐私保护法案》（Children's Online Privacy Protection Act）在内的可适用法律规范的要求。")]), _vm._v(" "), _c('div', [_vm._v("如果可适用法律规范所规定的您的有关权益与本《隐私政策》的内容有不符之处，以该可适用法律规范的规定为准，但前述可适用法律规范的规定如与本《隐私政策》约定的适用法律的强制性规定有冲突处，我们将在优先遵守该等强制性规定的前提下，尽可能遵守该可适用法律规范的规定。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("10. 通知和修订")]), _vm._v(" "), _c('div', [_vm._v("我们可能适时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。对于重大变更，我们会提供更显著的通知，您可以选择停止使用成者科技服务；在该种情况下，如您仍然继续使用成者科技服务的，即表示同意受经修订的本《隐私政策》的约束。")]), _vm._v(" "), _c('div', [_vm._v("任何修改都会将您的满意度置于首位。我们鼓励您在每次使用成者科技服务时都查阅我们的隐私政策。")]), _vm._v(" "), _c('div', [_vm._v("我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。")]), _vm._v(" "), _c('div', [_vm._v("最后，您必须对您的账号和密码信息负有保密义务。任何情况下，请小心妥善保管。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("11. 注销服务或帐号")]), _vm._v(" "), _c('div', [_vm._v("如您需要注销您的成者帐号，您可以在【我的-用户协议和隐私政策-注销账号】提交注销申请，并根据提示进行注销流程。由于注销成者帐号的操作将使您无法使用成者产品和服务，请您谨慎操作。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("12. 如何联系我们")]), _vm._v(" "), _c('div', [_vm._v("如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或成者科技的隐私措施的问题请与成者科技的协调人联系。")]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("查看详细说明也可访问 "), _c('a', {
    attrs: {
      "href": "https://passport.czur.cc/3dsharelist.html"
    }
  }, [_vm._v("https://passport.czur.cc/3dsharelist.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("电子邮箱： "), _c('a', {
    attrs: {
      "href": "mailto:service@czur.com"
    }
  }, [_vm._v("service@czur.com")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76cde9fa", module.exports)
  }
}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('h1', [_vm._v("用户协议")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("一、总则")]), _vm._v(" "), _c('div', [_vm._v("1.1 用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击\"同意\"按钮即表示用户与成者云达成协议，完全接受本协议项下的全部条款。")]), _vm._v(" "), _c('div', [_vm._v("1.2 用户注册成功后，成者云将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。")]), _vm._v(" "), _c('div', [_vm._v("1.3 用户一经注册成者云帐号，除非子频道要求单独开通权限，用户有权利用该账号使用成者云各个频道的单项服务，当用户使用成者云各单项服务时，用户的使用行为视为其对该单项服务的服务条款以及成者云在该单项服务中发出的各类公告的同意。")]), _vm._v(" "), _c('div', [_vm._v("1.4 成者云会员服务协议以及各个频道单项服务条款和公告可由成者云公司随时更新，且无需另行通知。您在使用相关服务时，应关注并遵守其所适用的相关条款。您在使用成者云提供的各项服务之前，应仔细阅读本服务协议。如您不同意本服务协议及/或随时对其的修改，您可以主动取消成者云提供的服务；您一旦使用成者云服务，即视为您已了解并完全同意本服务协议各项内容，包括成者云对服务协议随时所做的任何修改，并成为成者云用户。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("二、注册信息和隐私保护")]), _vm._v(" "), _c('div', [_vm._v("2.1 成者云帐号（即成者云用户ID）的所有权归成者云，用户完成注册申请手续后，获得成者云帐号的使用权。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，成者云不负任何责任。如果因注册信息不真实或更新不及时而引发的相关问题，成者云不负任何责任。")]), _vm._v(" "), _c('div', [_vm._v("2.2 用户应当通过真实身份信息认证注册账号，且用户提交的账号名称、头像等注册信息中不得出现违法和不良信息，经成者云审核，如存在上述情况，成者云将不予注册；同时，在注册后，如发现用户以虚假信息骗取账号名称注册，或其账号头像等注册信息存在违法和不良信息的，成者云有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。")]), _vm._v(" "), _c('div', [_vm._v("2.3 用户不应将其帐号、密码转让、出售或出借予他人使用，若用户授权他人使用帐户，应对被授权人在该帐户下发生所有行为负全部责任。")]), _vm._v(" "), _c('div', [_vm._v("2.4 成者云的隐私权保护声明说明了成者云如何收集和使用用户信息。您保证已经充分了解并同意成者云可以据此处理用户信息。")]), _vm._v(" "), _c('div', [_vm._v("2.5 在如下情况下，成者云可能会披露您的信息：")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 事先获得您的授权；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 您使用共享功能；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 根据法律、法规、法律程序的要求或政府主管部门的强制性要求；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 以学术研究或公共利益为目的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 为维护成者云的合法权益，例如查找、预防、处理欺诈或安全方面的问题；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 符合相关服务条款或使用协议的规定。")]), _vm._v(" "), _c('div', [_vm._v("2.6 您知悉并授权，成者云仅在必需的情况下使用或与关联公司同步您的信息，以为用户提供征信相关服务。")]), _vm._v(" "), _c('div', [_vm._v("2.7 为更好地向用户提供服务，您同意成者云通过短信等形式向您发送相关商业性服务信息。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("三、使用规则")]), _vm._v(" "), _c('div', [_vm._v("3.1用户在使用成者云服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("（1）上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("1） 反对宪法所确定的基本原则的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("2） 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("3） 损害国家荣誉和利益的")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("4） 煽动民族仇恨、民族歧视、破坏民族团结的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("5） 破坏国家宗教政策，宣扬邪教和封建迷信的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("6） 散布谣言，扰乱社会秩序，破坏社会稳定的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("7） 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("8） 侮辱或者诽谤他人，侵害他人合法权利的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("9） 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("10） 含有当地国家法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；")]), _vm._v(" "), _c('div', [_vm._v("（2）不得为任何非法目的而使用网络服务系统；")]), _vm._v(" "), _c('div', [_vm._v("（3）不利用成者云服务从事以下活动：")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("1) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("2) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("3) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("4) 故意制作、传播计算机病毒等破坏性程序的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("5) 其他危害计算机信息网络安全的行为。")]), _vm._v(" "), _c('div', [_vm._v("3.2用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿成者云与合作公司、关联公司，并使之免受损害。对此，成者云有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收成者云帐号、追究法律责任等措施。对恶意注册成者云帐号或利用成者云帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，成者云有权回收其帐号。同时，成者云公司会视司法部门的要求，协助调查。")]), _vm._v(" "), _c('div', [_vm._v("3.3用户不得对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。")]), _vm._v(" "), _c('div', [_vm._v("3.4用户须对自己在使用成者云服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在成者云公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予成者云公司等额的赔偿。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("四、服务内容")]), _vm._v(" "), _c('div', [_vm._v("4.1 成者云网络服务的具体内容由成者云根据实际情况提供。")]), _vm._v(" "), _c('div', [_vm._v("4.2 除非本服务协议另有其它明示规定，成者云所推出的新产品、新功能、新服务，均受到本服务协议之规范.")]), _vm._v(" "), _c('div', [_vm._v("4.3 为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、数据机或其它存取装置。")]), _vm._v(" "), _c('div', [_vm._v("4.4 鉴于网络服务的特殊性，用户同意成者云有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。成者云不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。")]), _vm._v(" "), _c('div', [_vm._v("4.5 成者云需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，成者云无需为此承担任何责任。成者云保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。")]), _vm._v(" "), _c('div', [_vm._v("4.6 本服务或第三人可提供与其它国际互联网上之网站或资源之链接。由于成者云无法控制这些网站及资源，您了解并同意，此类网站或资源是否可供利用，成者云不予负责，存在或源于此类网站或资源之任何内容、广告、产品或其它资料，成者云亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，成者云不承担任何责任。")]), _vm._v(" "), _c('div', [_vm._v("4.7 用户明确同意其使用成者云网络服务所存在的风险将完全由其自己承担。用户理解并接受下载或通过成者云服务取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。成者云对在服务网上得到的任何商品购物服务、交易进程、招聘信息，都不作担保。")]), _vm._v(" "), _c('div', [_vm._v("4.8 6个月未登录的帐号，成者云保留关闭的权利。")]), _vm._v(" "), _c('div', [_vm._v("4.9 成者云有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，成者云对用户和任何第三人均无需承担任何责任。")]), _vm._v(" "), _c('div', [_vm._v("4.10 终止服务")]), _vm._v(" "), _c('div', [_vm._v("您同意成者云得基于其自行之考虑，因任何理由，包含但不限于长时间（超过一年）未使用，或成者云认为您已经违反本服务协议的文字及精神，终止您的密码、帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，成者云可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，成者云对您或任何第三人均不承担任何责任。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("五、知识产权和其他合法权益（包括但不限于名誉权、商誉权）")]), _vm._v(" "), _c('div', [_vm._v("5.1 用户专属权利")]), _vm._v(" "), _c('div', [_vm._v("成者云尊重他人知识产权和合法权益，呼吁用户也要同样尊重知识产权和他人合法权益。若您认为您的知识产权或其他合法权益被侵犯，请按照以下说明向成者云提供资料∶请注意：如果权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果上述个人或单位不确定网络上可获取的资料是否侵犯了其知识产权和其他合法权益，成者云建议该个人或单位首先咨询专业人士。为了成者云有效处理上述个人或单位的权利通知，请使用以下格式（包括各条款的序号）：")]), _vm._v(" "), _c('div', [_vm._v("1. 权利人对涉嫌侵权内容拥有知识产权或其他合法权益和/或依法可以行使知识产权或其他合法权益的权属证明。")]), _vm._v(" "), _c('div', [_vm._v("2. 请充分、明确地描述被侵犯了知识产权或其他合法权益的情况并请提供涉嫌侵权的第三方网址（如果有）。")]), _vm._v(" "), _c('div', [_vm._v("3. 请指明涉嫌侵权网页的哪些内容侵犯了第2项中列明的权利。")]), _vm._v(" "), _c('div', [_vm._v("4. 请提供权利人具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件。")]), _vm._v(" "), _c('div', [_vm._v("5. 请提供涉嫌侵权内容在信息网络上的位置（如指明您举报的含有侵权内容的出处，即：指网页地址或网页内的位置）以便我们与您举报的含有侵权内容的网页的所有权人/管理人联系。")]), _vm._v(" "), _c('div', [_vm._v("6. 请在权利通知中加入如下关于通知内容真实性的声明： “我保证，本通知中所述信息是充分、真实、准确的，如果本权利通知内容不完全属实，本人将承担由此产生的一切法律责任。”")]), _vm._v(" "), _c('div', [_vm._v("7. 请您签署该文件，如果您是依法成立的机构或组织，请您加盖公章。")]), _vm._v(" "), _c('div', [_vm._v("请您把以上资料和联络方式书面发往以下地址：")]), _vm._v(" "), _c('div', [_vm._v("中国辽宁大连高新园区火炬路32号A座1001室")]), _vm._v(" "), _c('div', [_vm._v("大连成者科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("邮政编码：116023")]), _vm._v(" "), _c('div', [_vm._v("5.2成者云拥有本网站内所有资料的版权。任何被授权的浏览、复制、打印和传播属于本网站内的资料必须符合以下条件：")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 所有的资料和图象均以获得信息为目的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 所有的资料和图象均不得用于商业目的；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 所有的资料、图象及其任何部分都必须包括此版权声明；")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 本网站（www.czur.cc）所有的产品、技术与所有程序均属于成者云知识产权，在此并未授权。“CZUR”,“Czurtek”, “成者” 及相关图形等为成者云的注册商标。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-p"
  }, [_vm._v("• 未经成者云许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用。否则，成者云将依法追究法律责任。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("六、青少年用户特别提示")]), _vm._v(" "), _c('div', [_vm._v("青少年用户必须遵守全国青少年网络文明公约：要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。青少年用户必须遵守全国青少年网络文明公约：要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("七、其他")]), _vm._v(" "), _c('div', [_vm._v("7.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。")]), _vm._v(" "), _c('div', [_vm._v("7.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向成者云所在地的人民法院提起诉讼。")]), _vm._v(" "), _c('div', [_vm._v("7.3成者云未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。")]), _vm._v(" "), _c('div', [_vm._v("7.4如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。")]), _vm._v(" "), _c('div', [_vm._v("请您在发现任何违反本服务协议以及其他任何单项服务的服务条款、成者云各类公告之情形时，通知成者云。您可以通过如下联络方式同成者云联系：")]), _vm._v(" "), _c('div', [_vm._v("中国辽宁大连高新园区火炬路32号A座1001室")]), _vm._v(" "), _c('div', [_vm._v("大连成者科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("邮政编码：116023")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c89f091a", module.exports)
  }
}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(61);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e0b88fb0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-76cde9fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_CZUR.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-76cde9fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./privacy_CZUR.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(62);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7e327824", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c89f091a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./terms.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c89f091a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./terms.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ })

},[264]);


// WEBPACK FOOTER //
// static/js/module/privacy_part.a3ff940edb6f4d12c4fa.js